import script from "./RosterPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./RosterPanel.vue?vue&type=script&setup=true&lang=ts"

import "./RosterPanel.vue?vue&type=style&index=0&id=54b11d11&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b11d11"]])

export default __exports__